import React from 'react';
import Settings from '../../../Settings/Settings'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Style from './Styles/CompatibleProductComponentStyle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LoadingComponent from '../../LoadingComponent/LoadingComponent';
export default function AddCompatibleProduct(props) {
    const classes = Style();

    const [shopCompatibleProductsName, setShopCompatibleProductsName] = React.useState(props.element.shopCompatibleProductsName)
    const [shopCompatibleProductsManufacturer, setShopCompatibleProductsManufacturer] = React.useState(props.element.shopCompatibleProductsManufacturer)
    const [shopCompatibleProductsType, setShopCompatibleProductsType] = React.useState(props.element.shopCompatibleProductsType)
    const [shopCompatibleProductsCode, setShopCompatibleProductsCode] = React.useState(props.element.shopCompatibleProductsCode)
    const [shopCompatibleProductsID, setShopCompatibleProductsID] = React.useState(props.element.shopCompatibleProductsID)
    const [errorShopCompatibleProductsName, setErrorShopCompatibleProductsName] = React.useState(false)
    const [errorShopCompatibleProductsManufacturer, setErrorShopCompatibleProductsManufacturer] = React.useState(false)
    const [errorShopCompatibleProductsType, setErrorShopCompatibleProductsType] = React.useState(false)
    const [errorShopCompatibleProductsCode, setErrorShopCompatibleProductsCode] = React.useState(false)
    const [showAddForm, setShowAddForm] = React.useState(false)
    const [showEditForm, setShowEditForm] = React.useState(false)
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false)

    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods,
          deleteCompatibleProductAction : () => {
            let accountToken = ''
            if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
                accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
            }
            componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS +'/'+ props.element.setShopCompatibleProductsID + accountToken,{},'DELETE',null, (data) => {componentMethods.addError(componentConstants.language.LANG_COMPATIBLE_PRODUCT_DELETED); componentMethods.getCompatibleProducts()}, {}, false, (data) => {componentMethods.addError(componentConstants.language.LANG_COMPATIBLE_PRODUCTS_NOT_DELETED)})
        }
      }
    
      const componentProps = {
          ...props.componentProps
      }

      const saveCompatibleProductAction = () => {
        setErrorShopCompatibleProductsName(false)
        let method = "POST"
        let url = Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS

        if(shopCompatibleProductsID) {
            url = Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS + '/' + shopCompatibleProductsID
            method = "PUT"
        } 
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }

        componentMethods.setManagerState({loadingCompatibleProduct: true}, () => {
            let errors = []
            
            let requestObject =  {
                shopCompatibleProductsName: shopCompatibleProductsName,
                shopCompatibleProductsManufacturer: shopCompatibleProductsManufacturer,
                shopCompatibleProductsType: shopCompatibleProductsType,
            }
            
            if (shopCompatibleProductsCode) {
                requestObject.shopCompatibleProductsCode = shopCompatibleProductsCode
            }
            componentMethods.ajax(url += accountToken, 
               requestObject, 
               method, null, 
                (data) => {
                   componentMethods.addError(componentConstants.language.LANG_SUCCESSFULY_SAVED_COMPATIBLE_PRODUCT);
                   componentMethods.setManagerState({loadingCompatibleProduct: false})
                   if(props.addCompatibleProduct) {
                    clearCompatibleProduct()
                    setShowAddForm(false)
                   }
                   componentMethods.getCompatibleProducts()

               })
        })
      }
      const clearCompatibleProduct = () => {
        setShopCompatibleProductsName(null)
        setErrorShopCompatibleProductsName(false)
        setShopCompatibleProductsManufacturer(null)
        setShopCompatibleProductsType(null)
        setShopCompatibleProductsCode(null)
        setErrorShopCompatibleProductsManufacturer(false)
        setErrorShopCompatibleProductsType(false)
        setErrorShopCompatibleProductsCode(false)
      }

      if (componentMethods.getManagerState().loadingCompatibleProduct)
        return <LoadingComponent />

      if(!showAddForm && props.addCompatibleProduct) {
          return <Button color="primary" onClick={() => {setShowAddForm(true)}} fullWidth component="div" variant="contained" startIcon={<AccountTreeIcon />}>
                        {componentConstants.language.LANG_ADD_COMPATIBLE_PRODUCT}
                    </Button>
      }

      if(!showEditForm && props.editCompatibleProduct) {
          return <div>
              <Typography variant="subtitle1" gutterBottom>
                        {shopCompatibleProductsName} 
                </Typography>
              <Button color="secondary" onClick={() => {setShowEditForm(true)}} fullWidth component="div" variant="outlined" startIcon={<AccountTreeIcon />}>
                    {componentConstants.language.LANG_EDIT_COMPATIBLE_PRODUCT}
                </Button>
          </div>
      }
  return (<div style={classes.rootAddress}><React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <TextField fullWidth={true} value={shopCompatibleProductsName} error={errorShopCompatibleProductsName} onChange={(e)=> {setShopCompatibleProductsName(e.target.value)}}  label={componentConstants.language.LANG_COMPATIBLE_PRODUCTS_NAME} />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <TextField fullWidth={true} value={shopCompatibleProductsManufacturer} error={errorShopCompatibleProductsManufacturer} onChange={(e)=> {setShopCompatibleProductsManufacturer(e.target.value)}}  label={componentConstants.language.LANG_COMPATIBLE_PRODUCTS_MANUFACTURER} />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <TextField fullWidth={true} value={shopCompatibleProductsType} error={errorShopCompatibleProductsType} onChange={(e)=> {setShopCompatibleProductsType(e.target.value)}}  label={componentConstants.language.LANG_COMPATIBLE_PRODUCTS_TYPE} />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <TextField fullWidth={true} value={shopCompatibleProductsCode} error={errorShopCompatibleProductsCode} onChange={(e)=> {setShopCompatibleProductsCode(e.target.value)}}  label={componentConstants.language.LANG_COMPATIBLE_PRODUCTS_CODE} />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Button color="secondary" onClick={saveCompatibleProductAction} fullWidth component="div" variant="contained" startIcon={<AccountTreeIcon />}>
                        {componentConstants.language.LANG_SAVE_COMPATIBLE_PRODUCT}
                    </Button>
                </Grid> 
                {
                props.editCompatibleProduct ?
                    <React.Fragment>
                        <Grid item xs={12} md={12} lg={12}>
                            <Button color="secondary" onClick={() => {setShowEditForm(false)}} fullWidth component="div" variant="outlined" startIcon={<AccountTreeIcon />}>
                                {componentConstants.language.LANG_CANCEL_EDIT_COMPATIBLE_PRODUCT}
                            </Button>
                        </Grid>
                    </React.Fragment>
                :
                    null
                }
        </Grid>
    </React.Fragment>
    </div>
  );
}